'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _carousels = require('./carousels');

var _carousels2 = _interopRequireDefault(_carousels);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
    var eventFilterClick = function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(event) {
            var filterElement, filteredEventType, eventsItemsCollection;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            filterElement = event.target.tagName === 'DIV' ? event.target : event.target.parentElement;
                            filteredEventType = parseInt(filterElement.dataset.eventType);


                            window.unslickNewsCarouselGlobal();

                            eventsItemsCollection = document.querySelectorAll('#newsCarousel.news-carousel .new__item');
                            _context.next = 6;
                            return iterateAndMOveCarouselItems(eventsItemsCollection, filteredEventType, document.getElementById('newsCarouselStorage'));

                        case 6:
                            eventsItemsCollection = document.querySelectorAll('#newsCarouselStorage .new__item');
                            _context.next = 9;
                            return iterateAndMOveCarouselItems(eventsItemsCollection, filteredEventType, document.getElementById('newsCarousel'), true);

                        case 9:
                            window.initSlickNewsCarouselGlobal();

                        case 10:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        return function eventFilterClick(_x) {
            return _ref2.apply(this, arguments);
        };
    }();

    var iterateAndMOveCarouselItems = function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(collection, filteredEventType, parentElementToMove) {
            var moveBack = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, eventsItem, itemEventType, shouldBeActive;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context2.prev = 3;
                            _iterator = (0, _getIterator3.default)(collection);

                        case 5:
                            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                _context2.next = 16;
                                break;
                            }

                            eventsItem = _step.value;

                            if (eventsItem.dataset.eventType) {
                                _context2.next = 9;
                                break;
                            }

                            return _context2.abrupt('continue', 13);

                        case 9:
                            itemEventType = parseInt(eventsItem.dataset.eventType);
                            shouldBeActive = filteredEventType !== itemEventType;

                            if (moveBack) shouldBeActive = !shouldBeActive;

                            if (shouldBeActive) {
                                eventsItem.parentElement.removeChild(eventsItem);
                                parentElementToMove.appendChild(eventsItem);
                            }

                        case 13:
                            _iteratorNormalCompletion = true;
                            _context2.next = 5;
                            break;

                        case 16:
                            _context2.next = 22;
                            break;

                        case 18:
                            _context2.prev = 18;
                            _context2.t0 = _context2['catch'](3);
                            _didIteratorError = true;
                            _iteratorError = _context2.t0;

                        case 22:
                            _context2.prev = 22;
                            _context2.prev = 23;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }

                        case 25:
                            _context2.prev = 25;

                            if (!_didIteratorError) {
                                _context2.next = 28;
                                break;
                            }

                            throw _iteratorError;

                        case 28:
                            return _context2.finish(25);

                        case 29:
                            return _context2.finish(22);

                        case 30:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[3, 18, 22, 30], [23,, 25, 29]]);
        }));

        return function iterateAndMOveCarouselItems(_x2, _x3, _x4) {
            return _ref3.apply(this, arguments);
        };
    }();

    var setUpNewsCarouselFiltering = function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
            var _this = this;

            var filterItemsCollection, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, filterItem;

            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            filterItemsCollection = document.querySelectorAll('.new-item-filter-item');
                            _iteratorNormalCompletion2 = true;
                            _didIteratorError2 = false;
                            _iteratorError2 = undefined;
                            _context4.prev = 4;
                            _iterator2 = (0, _getIterator3.default)(filterItemsCollection);

                        case 6:
                            if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                                _context4.next = 15;
                                break;
                            }

                            filterItem = _step2.value;

                            if (!filterItem.clieckregistered) {
                                _context4.next = 10;
                                break;
                            }

                            return _context4.abrupt('continue', 12);

                        case 10:

                            filterItem.addEventListener('click', function () {
                                var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(event) {
                                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                                        while (1) {
                                            switch (_context3.prev = _context3.next) {
                                                case 0:
                                                    _context3.next = 2;
                                                    return eventFilterClick(event);

                                                case 2:
                                                    return _context3.abrupt('return', _context3.sent);

                                                case 3:
                                                case 'end':
                                                    return _context3.stop();
                                            }
                                        }
                                    }, _callee3, _this);
                                }));

                                return function (_x6) {
                                    return _ref5.apply(this, arguments);
                                };
                            }());
                            filterItem.clieckregistered = true;

                        case 12:
                            _iteratorNormalCompletion2 = true;
                            _context4.next = 6;
                            break;

                        case 15:
                            _context4.next = 21;
                            break;

                        case 17:
                            _context4.prev = 17;
                            _context4.t0 = _context4['catch'](4);
                            _didIteratorError2 = true;
                            _iteratorError2 = _context4.t0;

                        case 21:
                            _context4.prev = 21;
                            _context4.prev = 22;

                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }

                        case 24:
                            _context4.prev = 24;

                            if (!_didIteratorError2) {
                                _context4.next = 27;
                                break;
                            }

                            throw _iteratorError2;

                        case 27:
                            return _context4.finish(24);

                        case 28:
                            return _context4.finish(21);

                        case 29:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this, [[4, 17, 21, 29], [22,, 24, 28]]);
        }));

        return function setUpNewsCarouselFiltering() {
            return _ref4.apply(this, arguments);
        };
    }();

    return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return setUpNewsCarouselFiltering();

                case 2:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _callee5, this);
}));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/events.js
// module id = 1173
// module chunks = 0